<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :close-on-click-modal="false" :lock-scroll="false" :before-close="closeDialog">
    <div v-loading.fullscreen="loading">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <div class="space_between">
        <el-form-item class="login_form_item" prop="companyName">
          <div class="login_title">Company Name</div>
          <el-input class="login_ipt" v-model="ruleForm.companyName" placeholder="Please enter Company Name"></el-input>
        </el-form-item>
        <el-form-item class="login_form_item" prop="taxCode">
          <div class="login_title">Tax ID</div>
          <el-input class="login_ipt" v-model="ruleForm.taxCode" placeholder="Please enter Tax ID"></el-input>
        </el-form-item>
        </div>
        <div class="space_between">
          
          <el-form-item class="login_form_item" prop="userName">
            <div class="login_title">Consignee</div>
            <el-input class="login_ipt" v-model="ruleForm.userName" placeholder="Please enter consignee"></el-input>
          </el-form-item>
          <el-form-item class="login_form_item" prop="mobile">
            <div class="login_title">Phone number</div>
            <el-input class="login_ipt" v-model="ruleForm.mobile" placeholder="Please enter phone number"></el-input>
          </el-form-item>
        </div>
        <div class="space_between">
          <el-form-item class="login_form_item" prop="email">
            <div class="login_title">Email Address</div>
            <el-input class="login_ipt" v-model="ruleForm.email" placeholder="Please enter Email Address"></el-input>
          </el-form-item>
          <el-form-item class="login_form_item" prop="country">
          <div class="login_title">Country/Region</div>
          <!-- <el-input class="login_ipt" v-model="ruleForm.country" placeholder="Please enter Country" @input="setInput()"></el-input> -->
          <el-select v-model="ruleForm.country" placeholder="Please enter Country" style="width:100%" @change="nationChange">
            <el-option
              v-for="item in nationList"
              :key="item._id"
              :label="item.EnName"
              :value="item.Code">
            </el-option>
          </el-select>
        </el-form-item>
        </div>
        <div class="space_between">
        
        <el-form-item class="login_form_item" prop="provice">
          <div class="login_title">State</div>
          <el-cascader class="login_ipt" popper-class="provinceList" separator=" " placeholder="Please select your region" v-model="ruleForm.provice" :options="provinceList" @change="proviceChange"></el-cascader>
        </el-form-item>
      <el-form-item class="login_form_item" prop="city">
          <div class="login_title">City</div>
          <el-input class="login_ipt" v-model="ruleForm.city" placeholder="Please enter city"></el-input>
        </el-form-item>
      </div>
      
        <el-form-item class="login_form_item" prop="address">
          <div class="login_title">Street address</div>
          <el-input class="login_ipt" v-model="ruleForm.address" placeholder="Please enter address"></el-input>
        </el-form-item>
        
      <el-form-item class="login_form_item" prop="zipCode">
            <div class="login_title">ZIP Code</div>
            <el-input class="login_ipt" v-model="ruleForm.zipCode" placeholder="Please enter ZIP Code"></el-input>
          </el-form-item>
        <div class="tips">
          <div>Default address</div>
          <el-switch v-model="ruleForm.delivery"></el-switch>
        </div>
        <div class="tips" v-if="isSet"></div>
        <div class="login_btn_between">
          <el-button class="login_btn" @click="resetForm('ruleForm')">Cancel</el-button>
          <el-button class="login_btn" :disabled='disabled' type="primary" @click="submitForm('ruleForm')">Confirm</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import { getarea } from "@/api/area";
import { getInfo,countries } from "@/api/public";
export default {
  name: 'getaddress',
  components: {},
  data() {
    return {
      userInfo:getInfo() || {},
      loading: false,
      provinceList:[],
      dislogType: this.$enumInfo.dislogType,
      flagType: 'password',
      flag: false,
      checked: true,
      disabled: false,
      dialogClass: 'address',
      proviceText: '',
      nationList:'',
      ruleForm: {
        companyName:'',
        taxCode:'',
        userName: '',
        mobile: '',
        email:'',
        zipCode:'',
        city:'',
        country:'',
        provice: [],
        address: '',
        delivery: false,
      },
      rules: {
        companyName: [
          { required: true, message: 'Please enter Company Name', trigger: 'blur' },
        ],
        taxCode: [
          { required: true, message: 'Please enter Tax ID', trigger: 'blur' },
        ],
        userName: [
          { required: true, message: 'Please enter consignee', trigger: 'blur' },
        ],
        mobile: [
          { required: true, message: 'Please enter phone number', trigger: 'blur' },
          { pattern: /^\+?[1-9]\d{1,14}$/, message: 'Please enter phone number', trigger: 'blur' },
        ],
        zipCode: [
          { required: true, message: 'Please enter ZIP Code', trigger: 'blur' },
        ],
        email: [
          { required: true, message: 'Please enter Email Address', trigger: 'blur' },
          { type:'email', message: 'Please enter Email Address', trigger: 'blur' },
        ],
        country: [
          { required: true, message: 'Please enter Country', trigger: 'change' },
        ],
        provice: [
          { required: true, message: 'Please select your region', trigger: 'change' },
        ],
        city: [
          { required: true, message: 'Please enter city', trigger: 'change' },
        ],
        address: [
          { required: true, message: 'Please enter address', trigger: 'blur' },
        ]
      },
    }
  },
  props: {
    list:{},
    isSet: Boolean,
    title: String,
    domVisible: Boolean,
  },
  created() {
    this.getNationList()
  },
  mounted() {
    let that = this
    this._keydownHandler = function(e) {
      if (e.keyCode === 13) {
          that.submitForm('ruleForm')
        }
    }
    window.addEventListener('keydown', this._keydownHandler)
  },
  beforeDestroy() {
    if (this._keydownHandler) {
      window.removeEventListener('keydown', this._keydownHandler)
    }
  },
  methods: {
    getNationList() {
      let that = this;
      this.$get(this.$interface.GetNationList).then(async res => {
        that.nationList = countries(res) 
        if(that.list){
            let arrayCountry=that.nationList.filter(item=>item.EnName===that.list.Country)
            let country=''
            if(arrayCountry.length>0){
              country=arrayCountry[0].Code
            }
           that.setDetail(that.list,country)
        }
        
      })
    },
    async provinceFn(val){
      let that=this
      // 标记当前请求的国家代码
      that._currentCountryCode = val
      that.provinceList=[]
      if(val==='CN'){
        return that.getChinaAreas()
      }else{
        return that.getOtherAreas(val)
      }
      
    },
    getChinaAreas(){
      let that=this
      const currentCode = that._currentCountryCode
      that.$get(that.$interface.GetChinaAreas,'').then(res=>{
        // 检查是否是最新的请求
        if(that._currentCountryCode !== currentCode) return
        if(res.Result==1){
          that.provinceList=getarea(res.Data) || []
        }else{
              that.$message.error(res.Msg);
            }

      })
    },
    getOtherAreas(code){
      let that=this
      const currentCode = that._currentCountryCode
      let data = { code: code }
      that.$get(that.$interface.GetAreas,data).then(res=>{
        // 检查是否是最新的请求
        if(that._currentCountryCode !== currentCode) return
        if(res.Result){
          that.provinceList=getarea(res.Data) || []
        }else{
          that.$message.error(res.Msg);
        }
      })
    },

    // 编辑时填写默认值
    async setDetail(val,MemberSource){
      if(!this.isSet){
        let provice=val.Provice;
        let city=val.City;
        
        if(MemberSource==='CN'){
          provice=provice.split('-')
        }
        await this.provinceFn(MemberSource)
        this.ruleForm={
          companyName:val.CompanyName,
          taxCode:val.TaxCode,
          userName: val.UserName,
          mobile: val.Mobile,
          email:val.Email,
          city:city,
          country:MemberSource,
          zipCode:val.ZipCode,
          provice: provice,
          address: val.AddressDetail,
          delivery: val.IsDefault,
        }
        this.disabled = false
      }
    },
    // 关闭
    closeDialog(val) {
      this.$emit('closeDialog', 'address', false)
    },
    // 判断input是否有值
    setInput() {
      // 该方法已弃用，保留以备后用
      // if (this.ruleForm.userName != '' && this.ruleForm.mobile != '' && this.ruleForm.provice.length > 0 && this.ruleForm.address != '') {
      //   this.disabled = false
      // } else {
      //   this.disabled = true
      // }
    },
    nationChange(e){
      let that=this
      that.provinceFn(e)
    },
    // 所在区域 数组变成字符串 格式：xx-xx-xx
    proviceChange() {
      let that = this;
      //that.setInput();
      //console.log(this.ruleForm,'this.ruleForm')
      let data = that.ruleForm.provice||[];
      if(that.ruleForm.country==='CN'){
        if(data.length>0){
          this.proviceText=data[0]+"-"+data[1]+"-"+data[2]
        }
      }else{
        that.proviceText=data[0]
      }
    },
    // 提交表单
    submitForm(formName) {
      let that = this;
      this.proviceChange();
      //return
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.disabled=true;
          that.loading=true;
          
          let country='China'
          let city=that.ruleForm.city
          if(that.ruleForm.country==='CN'){
              city=that.ruleForm.provice[1]
              if(that.ruleForm.provice[1]==='市辖区'){
                city=that.ruleForm.provice[0]
              }
          }
          try{
            let arrayCountry=that.nationList.filter(item=>item.Code===that.ruleForm.country)
            if(arrayCountry.length>0){
              country=arrayCountry[0].EnName
            }
          }catch(e){}
          let data={
            memberId:that.userInfo._id,
            companyName:that.ruleForm.companyName,
            taxCode:that.ruleForm.taxCode,
            userName:that.ruleForm.userName,
            mobile:that.ruleForm.mobile,
            zipCode:that.ruleForm.zipCode,
            email:that.ruleForm.email,
            provice:that.proviceText,
            city:city,
            addressDetail:that.ruleForm.address,
            country:country,
            isDefault:that.ruleForm.delivery,
          }
          // console.log(data,'data')
          // return
          let url=that.$interface.SaveAddress
          // 是否编辑地址
          if(!that.isSet){
            data=Object.assign({}, data, {id:that.list._id})
            url=that.$interface.UpdateAddress
          }
          that.$post(url,data).then(res=>{
            if(res.Result!=0){
              that.closeDialog()
            }else{
              this.$message.error(res.Msg);
            }
            that.disabled=false;
            that.loading=false;
          })
        }
      });
    },
    // 清空表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.closeDialog()
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/address.css";

</style>



// WEBPACK FOOTER //
// src/components/dialog/address.vue